// extracted by mini-css-extract-plugin
export default {"button":"primary__button___frFdc base__button___zT0JW"};